import angular from 'angular';
import { TrialDaysLeftCounterPill } from '@alquilatucancha/backoffice-integration';
import common from './core.module';

const moduleName = 'atc-days-left-counter';

angular
    .module(moduleName, [common])

    .directive('daysLeftCounter', [
        'Backoffice',
        'Club',
        (Backoffice, Club) => ({
            restrict: 'E',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], TrialDaysLeftCounterPill, {
                    daysLeft: getDaysLeft(Club.created_at),
                });

                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ]);

function getDaysLeft(createdAt) {
    const daysForFree = 31;
    const clubCreation = new Date(createdAt);
    const today = new Date();
    const difference = today - clubCreation;
    const daysOnline = Math.floor(difference / (1000 * 60 * 60 * 24));

    return daysForFree - daysOnline;
}

export default moduleName;
